import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { HeaderResult } from './../header-result';
import { LineResult } from './../line-result';
import { MenuServiceInt } from '@core/_services/menu.serviceint';
import { MessagesService } from '@core/_services/messages.service';
import { CommonService } from '@service/common.service';
import { updateResultValue } from '@core/_utils/tools.utils';
import { lastValueFrom } from 'rxjs';
import { ApiV6Service } from '@service/apiv6.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-edit-results',
    templateUrl: './edit-results.component.html',
    styleUrls: ['./edit-results.component.scss'],
})
export class EditResultsComponent implements OnInit {
    public selectedResult: HeaderResult;
    public selectedItem: LineResult;
    public resultResult: any[];
    public resultItem: any[] = [];

    @Input()
    public item: any;

    @Input()
    public indexList = [];
    @Input()
    public systemList = [];
    @Input()
    public propertiesList = [];
    @Input()
    public propBskList = [];

    @Input()
    public groupList = [];

    @Input()
    public userList = [];

    @Output()
    public onCancel: EventEmitter<any> = new EventEmitter();

    @Output()
    public onValidate: EventEmitter<any> = new EventEmitter();

    @Output()
    public onDeleteItem: EventEmitter<any> = new EventEmitter();

    constructor(
        private api: ApiV6Service,
        protected _messageService: MessagesService,
        public menu: MenuServiceInt,
        private commonService: CommonService,
        private translate: TranslateService
    ) {
        this.menu.display = true;
        this.selectedItem = new LineResult();
        this.selectedResult = new HeaderResult();
    }

    ngOnInit() {
        this.getResult(this.item.id);
        this.commonService.checkReset();
    }

    private async getResult(id) {
        let wRes: any;
        try {
            wRes = await lastValueFrom(this.api.execUrlAction('getresult', id ));
            this.resultResult = wRes[0];
            this.selectedResult.Clear();
            if (id !== 0) {
                this.loadResultData(this.resultResult);
            }
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
        }
    }

    private loadResultData(adata) {
        this.selectedResult.load(adata);
        this.resultItem = [...this.selectedResult.reqDetail];
    }

    delete(data) {
        this.onDeleteItem.emit({ index: this.item.index, id: this.item.id, data: data });
    }

    public async validate(result) {
        let wRes: any = {};
        // id de la requête forcé à 0 : création
        if (result.duplicate === true) {
            result.entete.id = 0;
        }
        const wParams = updateResultValue(result.entete, result.detail);
        try {
            wRes.data = await lastValueFrom(this.api.execUrlAction('updateresult', wParams ));
            this.onValidate.emit({
                index: this.item.index,
                id: this.item.id,
                data: wRes.data,
                duplicate: result.duplicate,
            });               
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Update_KO'));
        }      
    }

    cancel(event) {
        this.onCancel.emit({ index: this.item.index, id: this.item.id });
    }
}
